enum StoreAvailabilityDataSourceEnum {
	disabled = 'disabled',
	DEXF = 'DEXF'
}

export default StoreAvailabilityDataSourceEnum;
